$(document).on('nc.sidePanel.shown', '[id="data-side-panel-relatable-selector"]', function (e) {
    registerRelatableSelect(window.sidePanels.getCurrentSidePanel());
}).on('nc.sidePanel.reloaded', '[id="data-side-panel-relatable-selector"]', function (e) {
    registerRelatableSelect(window.sidePanels.getCurrentSidePanel());
});

function registerRelatableSelect(sidebar) {
    sidebar.content.find('tbody tr').click((e) => {
        let row = $(e.target).closest('tr');
        let morph = row.find('td[data-column="morph"] i')
        let inputGroup = sidebar.target.closest('.input-group');
        inputGroup.find('input[type="hidden"][id="relatable_type"]')
            .val(morph.data('type')).trigger('change');
        inputGroup
            .find('input[type="hidden"][id="relatable_id"]')
            .val(morph.data('id')).trigger('change');
        inputGroup
            .find('input[type="text"]')
            .val(morph.data('title').trim())
            .trigger('change');
        sidebar.close();
    });
}
